import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NAVIGATION_GROUPS, ROUTE_PATHS } from '../config/navigation';

const getComparablePath = (path) => {
  const [pathname] = path.split('?');
  return pathname;
};

const Sidebar = () => {
  const location = useLocation();
  const [expandedMenus, setExpandedMenus] = useState({});

  const isActive = (path) => `${location.pathname}${location.search}` === path;
  const isPathInCurrentSection = useCallback(
    (path) => getComparablePath(path) === location.pathname,
    [location.pathname]
  );

  const activeGroupKey = useMemo(() => {
    const activeGroup = NAVIGATION_GROUPS.find((group) =>
      group.items.some((item) => !item.external && isPathInCurrentSection(item.path))
    );

    return activeGroup?.key || null;
  }, [isPathInCurrentSection]);

  useEffect(() => {
    if (!activeGroupKey) {
      return;
    }

    setExpandedMenus((prev) => ({
      ...prev,
      [activeGroupKey]: true
    }));
  }, [activeGroupKey]);

  const toggleSubmenu = (menuKey) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [menuKey]: !prev[menuKey]
    }));
  };

  return (
    <div className="sidebar modern-sidebar">
      <div className="sidebar-logo modern-sidebar-logo">
        <Link to={ROUTE_PATHS.dashboard} className="text-decoration-none">
          <img
            src="https://www.kolin.com.tr/Templates/Default/assets/img/logo@2x.png"
            alt="Kolin İnşaat"
            className="kolin-logo modern-sidebar-logo-img"
          />
        </Link>
        <div className="sidebar-close modern-sidebar-close" id="sidebar-close">
          <i className="bx bx-left-arrow-alt"></i>
        </div>
      </div>

      <div className="simlebar-sc" data-simplebar>
        <ul className="sidebar-menu tf">
          <li className="modern-sidebar-item">
            <Link
              to={ROUTE_PATHS.dashboard}
              className={`modern-sidebar-link ${isActive(ROUTE_PATHS.dashboard) ? 'active' : ''}`}
            >
              <i className="bx bxs-home modern-sidebar-icon"></i>
              <span>Anasayfa</span>
            </Link>
          </li>

          {NAVIGATION_GROUPS.map((group) => {
            const isGroupActive = group.items.some(
              (item) => !item.external && isPathInCurrentSection(item.path)
            );

            return (
              <li key={group.key} className="sidebar-submenu modern-sidebar-item">
                <button
                  className={`modern-sidebar-dropdown ${
                    expandedMenus[group.key] || isGroupActive ? 'active' : ''
                  }`}
                  onClick={() => toggleSubmenu(group.key)}
                >
                  <div className="modern-sidebar-dropdown-content">
                    <i className={`${group.icon} modern-sidebar-icon`}></i>
                    <span>{group.label}</span>
                  </div>
                  <div className="modern-sidebar-dropdown-icon">
                    <i className={`bx bx-chevron-down ${expandedMenus[group.key] ? 'active' : ''}`}></i>
                  </div>
                </button>

                <ul className={`modern-sidebar-dropdown-menu ${expandedMenus[group.key] ? 'active' : ''}`}>
                  {group.items.map((item) => (
                    <li key={item.key} className="modern-sidebar-dropdown-item">
                      {item.external ? (
                        <a
                          href={item.path}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="modern-sidebar-dropdown-link"
                        >
                          <span>{item.label}</span>
                          {item.meta && <small className="ms-2 text-muted">{item.meta}</small>}
                        </a>
                      ) : (
                        <Link
                          to={item.path}
                          className={`modern-sidebar-dropdown-link ${isActive(item.path) ? 'active' : ''}`}
                        >
                          <span>{item.label}</span>
                          {item.meta && <small className="ms-2 text-muted">{item.meta}</small>}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
